import serverApi from "../../utils/serverApi"

const transactionService = {
    getTransactions: (data) =>  serverApi({ uri: 'transactions', method: 'GET', data }),
};

export default transactionService;
